import { Form, FormInstance, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

import { SharedForm } from '@components';
import { L } from '@lib';
import { Rules } from '@utils';

interface IProps {
  form: FormInstance<any>;
  onCancel: (value: boolean) => void;
  onFinish: (values: any) => Promise<void>;
}

const CreateServiceGroupForm: React.FC<IProps> = (props) => {
  return (
    <SharedForm
      {...props}
      onCancel={() => {
        props.form.resetFields();
        props.onCancel(false);
      }}
      submitTitle="Save"
      name="createServiceGroup"
      layout="vertical"
    >
      <Form.Item name="name" label={L('Service category name')} rules={Rules.required}>
        <Input placeholder={L('Enter service category name')} />
      </Form.Item>

      <Form.Item name="description" label={L('Short description about the service category')}>
        <TextArea
          placeholder={L('Please write description')}
          autoSize={{ minRows: 3 }}
          maxLength={100}
          showCount
        />
      </Form.Item>
    </SharedForm>
  );
};

export default CreateServiceGroupForm;
